import i18n from 'i18next';

const formatCurrency = (data) => {
    let number = typeof data === "string" ? Number(data) : data;

    // Get current language
    const currentLanguage = i18n.language;

    // Define currency symbols/format per language
    const currencyConfig = {
        'en': { locale: 'en-IN', currency: 'INR', symbol: '₹' },
        'hi': { locale: 'en-IN', currency: 'INR', symbol: '₹' },
        'ma': { locale: 'en-IN', currency: 'INR', symbol: '₹' },
        'gu': { locale: 'en-IN', currency: 'INR', symbol: '₹' },
        'be': { locale: 'en-IN', currency: 'INR', symbol: '₹' },
        'ar': { locale: 'ar-SA', currency: 'SAR', symbol: 'ر.س' },
        'en-SG': { locale: 'en-SG', currency: 'SGD', symbol: 'S$' },
    };

    const baseLanguage = currentLanguage.split('-')[0];
    const config = currencyConfig[currentLanguage] || currencyConfig[baseLanguage] || currencyConfig['en'];

    try {
        // Try using Intl.NumberFormat directly
        const formatter = new Intl.NumberFormat(config.locale, {
            style: 'currency',
            currency: config.currency,
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        });

        return formatter.format(number);
    } catch (error) {
        // Fallback to simple formatting
        return `${config.symbol} ${number.toFixed(2)}`;
    }
};

export default formatCurrency;